import * as fromFeature from '../reducers';
import { createSelector } from '@ngrx/store';

export const getMenu = createSelector(fromFeature.featureSelector, (state: fromFeature.FeatureState) => state.menu);
export const getUser = createSelector(getMenu, (state) => state.user);
